var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cash-coin",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0a579b",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M17.875,27.375a9.5,9.5,0,1,0-9.5-9.5A9.5,9.5,0,0,0,17.875,27.375Zm11.875-9.5A11.875,11.875,0,1,1,17.875,6,11.875,11.875,0,0,1,29.75,17.875Z",
    transform: "translate(8.25 8.25)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M9.439,16.68c.112,1.415,1.23,2.517,3.237,2.651v1.045h.891V19.323c2.078-.145,3.292-1.256,3.292-2.867,0-1.468-.926-2.223-2.589-2.613l-.7-.166v-2.85a1.663,1.663,0,0,1,1.594,1.263h1.563c-.112-1.366-1.283-2.432-3.156-2.548V8.5h-.891V9.569C10.9,9.742,9.7,10.809,9.7,12.319c0,1.335.9,2.185,2.392,2.532l.589.145v3.021a1.8,1.8,0,0,1-1.653-1.337H9.437Zm3.23-3.216c-.876-.2-1.351-.618-1.351-1.24a1.441,1.441,0,0,1,1.358-1.373v2.613h-.007ZM13.7,15.236c1.066.247,1.556.646,1.556,1.351,0,.805-.61,1.356-1.684,1.458V15.207l.128.029Z",
    transform: "translate(12.976 11.688)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M2.375,0A2.375,2.375,0,0,0,0,2.375v19A2.375,2.375,0,0,0,2.375,23.75h9.7a14.4,14.4,0,0,1,.613-2.375H7.125a4.75,4.75,0,0,0-4.75-4.75v-9.5a4.75,4.75,0,0,0,4.75-4.75h23.75a4.75,4.75,0,0,0,4.75,4.75V15.5A14.3,14.3,0,0,1,38,18.245V2.375A2.375,2.375,0,0,0,35.625,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M15.5,7.946l0-.2a4.75,4.75,0,1,0-7.439,3.919A14.207,14.207,0,0,1,15.5,7.946Z",
    transform: "translate(8.25 4.126)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash-icon.b833b7a5fffad35ff2d4aa44bd26af0d.svg";
export { ForwardRef as ReactComponent };